module.exports = __webpack_public_path__ + "img/筆記裝飾_月亮.ba1cf33a.svg";